import React from 'react';
import ReactModal from 'react-modal';

export default function Modal({ isOpen, height, width, children, overflow, closePopup, padding = '20px 16px 28px' }) {
  const overlayStyles = {
    backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const contentStyles = {
    display: 'flex',
    padding,
    position: 'relative',
    inset: 'unset',
    width,
    height,
    background: '#FFFFFF',
    zIndex: '10000',
  };

  if (overflow) {
    contentStyles.overflow = 'hidden';
  }

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closePopup}
      shouldCloseOnEsc={false}
      style={{
        overlay: overlayStyles,
        content: contentStyles,
      }}
    >
      {children}
    </ReactModal>
  );
}
